// Main Setting
// import jCompanyFeature from '@/views/company/jCompanyFeature';
import jCompanyProfile from '@/views/company/jCompanyProfile';
import jCompanySetting from '@/views/company/jCompanySetting';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';
import onlyAdmin from '@/middleware/onlyAdmin';

export default [
  // Main setting
  // {
  //   path: '/administrator/company/feature',
  //   name: 'jCompany Feature',
  //   component: jCompanyFeature,
  //   meta: {
  //     title: 'Company Feature',
  //     middleware: [auth, admin, log],
  //     layout: 'jSettingWrapper',
  //   },
  // },
  {
    path: '/administrator/company/profile',
    name: 'jCompany Profile',
    component: jCompanyProfile,
    meta: {
      title: 'Company Profile',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/administrator/company/settings',
    name: 'jCompany Settings',
    component: jCompanySetting,
    meta: {
      title: 'Company Settings',
      middleware: [auth, onlyAdmin],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/administrator/company/settings/:tab',
    name: 'jCompany Settings',
    component: jCompanySetting,
    meta: {
      title: 'Company Settings',
      middleware: [auth, onlyAdmin],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterCompany.js